// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__RJoin","itemTitle":"ClientEmergencyInfo_itemTitle__1nC2Q","itemText":"ClientEmergencyInfo_itemText__3N_PE"};